export enum LinkVariant {
  Text = 'text',
  Contained = 'contained',
  Outlined = 'outlined',
}

export enum LinkSize {
  sm = 'sm',
  m = 'm',
  lg = 'lg',
  fullWidth = 'fullWidth',
}

export type LinkFormData = {
  url: string;
  label: string;
  openInNewTab: boolean;
  variant: LinkVariant;
  size: LinkSize;
};

export type AnchorLinkProps = {
  href: string;
  children: string;
};
